import { Grid } from "@mui/material";
import moment from "moment";
import { PlanWeek } from "@readyfit-common/models";
import DayCard from "src/grading/components/DayCard/DayCard";
import EmptyDayCard from "src/grading/components/EmptyDayCard/EmptyDayCard";
import useStyles from "./Days.style";

interface DaysProps {
  week: PlanWeek;
  isEditable?: boolean;
  isTemplate?: boolean;
}

const Days = ({ week, isEditable, isTemplate }: DaysProps) => {
  const css = useStyles();
  const days = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

  const { workouts = [] } = week;

  const newDays = days.map(
    (i, index) => workouts.filter((w) => w.dayNumber === index + 1) || i,
  );

  return (
    <Grid container className={css.wrapperDays}>
      {newDays.map((i, index) => {
        const date = moment(week?.start)
          .add(index, "days")
          .format("YYYY-MM-DD");

        const isToday = moment(date).isSame(moment(), "day");

        return (
          <Grid key={index}>
            {i?.[0]?.id ? (
              <DayCard
                workouts={i}
                week={week}
                isToday={isToday}
                isEditable={isEditable}
                isTemplate={isTemplate}
                index={index}
                date={date}
              />
            ) : (
              <>
                <EmptyDayCard
                  dayOfTheWeek={days[index]}
                  date={date}
                  isToday={isToday}
                  isEditable={isEditable}
                  week={week}
                  isTemplate={isTemplate}
                  index={index}
                />
              </>
            )}
          </Grid>
        );
      })}
    </Grid>
  );
};

export default Days;
